export default "/images/9fc600ff88f555f48bd1b2d512ca5f55.jpg";